export default "__VITE_ASSET__DKdW57Nf__"